import styled from '@emotion/styled'
import { css, keyframes } from '@emotion/react'
import { Box, Flex } from 'rebass'

import { getResultText } from '../../../utils/utility'
import Button from '../../../components/Button'
import Thumb, { THUMB_SIZE } from '../../../components/Thumb'
import CONST from '../../../utils/const'

const Title = styled('div')`
  color: white;
  text-transform: uppercase;
  font-size: 10px;
  padding-top: 40px;
  text-align: center;
`

const Result = styled('div')`
  text-transform: uppercase;
  color: white;
  font-size: 30px;
`

const spinAndZoom = keyframes`
  0% {
    transform: scale(0) rotate(0deg);
  }
  100% {
    transform: scale(1) rotate(360deg);
  }
`

const spinAndZoomCss = css`
  animation: ${spinAndZoom} 0.5s ease-in-out;
`

const ResultAnnounceMobile = ({ userChose, computerChose, result, onPlayAgainClick }) => {
  return (
    <>
      <Flex justifyContent="space-around">
        <Flex flexDirection="column">
          <Thumb
            thumbSize={THUMB_SIZE.MEDIUM}
            thumbType={userChose}
            hasWon={result === CONST.RESULT.USER}
          />
          <Title>You Picked</Title>
        </Flex>
        <Flex flexDirection="column">
          <Thumb
            thumbSize={THUMB_SIZE.MEDIUM}
            thumbType={computerChose}
            hasWon={result === CONST.RESULT.COMPUTER}
          />
          <Title>The House Picked</Title>
        </Flex>
      </Flex>

      <Flex css={spinAndZoomCss} flexDirection="column" alignItems="center" justifyContent="center">
        <Result>{getResultText(result)}</Result>
        <Box pt={2}>
          <Button onClick={onPlayAgainClick}>Play again</Button>
        </Box>
      </Flex>
    </>
  )
}

export default ResultAnnounceMobile
